import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Pagination from '../Pagination/Paginations.js';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const DepartmentShift = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	const [docfile,setDocFile]=useState(null);
	const [isImporting,setIsImporting]=useState(false);
	
		const handleDocumentChange = (event) => {
			
			const file = event.target.files[0];
			if (file) {
				setDocFile(file);
			//   setPreview(URL.createObjectURL(file)); // Preview image
			}
		  };

	const [user, setUser] = useState({
		start_date: "",
		end_date: "",
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	const [url_name, setUrlname] = useState('');
	const [url_id, setUrlid] = useState('');
	const [url_link, setUrllink] = useState('');
	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	// const itemsPerPage = 10;
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	let filteredItems = data.filter((item) =>



		`${item.department_name.toLowerCase()}${item.emp_info.toLowerCase()}${item.shift_code.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	};



	

	useEffect(() => {
		axios.get(API_BASE_URL + '/hr_weekoff_exceed_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//  .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])






	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);





	const handleDutyRosterSubmit = (e) => {

		e.preventDefault();

		// block repeat submits while an import is already running
		if (isImporting) {
			return;
		}

		setIsImporting(true);

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/hodimportdutyhost', {duty_host_file:docfile}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				setIsImporting(false);
				toast.error(response.data.message, {
					toastId: "hod-import-duty-roster",
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				setIsImporting(false);
				toast.error(response.data.message, {
					toastId: "hod-import-duty-roster",
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else {
				setIsImporting(false);
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);

			setIsImporting(false);

			toast.error(error.response.data.message, {
				toastId: "hod-import-duty-roster",
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Fetch options from Laravel API
  useEffect(() => {
    axios.get(API_BASE_URL + '/under_incharge_emp', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	}) // Change URL as needed
      .then((response) => {
		// console.log(response.data);
        const formattedOptions = response.data.map((item) => ({
          value: item.employee_id,
          label: item.emp_info,
        }));

		// console.log(formattedOptions);
		// alert(formattedOptions);
        setOptions(formattedOptions);
      })
      .catch((error) => console.error("Error fetching options:", error));
  }, []);

  // Handle selection change
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const [shiftcode,setShiftCodeValue]= useState("");
  const [officeshift,setOfficeShift]= useState([]);

  const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };

  const handleShiftCode = async () => {

	axios.get(API_BASE_URL + '/read_shift_info', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
//    .then(res1 => console.log(res1.data))
	.then(res1 => setOfficeShift(res1.data))
	.catch(err => console.log(err))
   };


   useEffect(() => {
	handleShiftCode();
  }, []);



 

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							<form>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-header d-flex justify-content-between align-items-center">
	<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
			<path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
			<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
		</svg>
		Import Duty Roster
	</h3>
</div>
<div className="card-body">
<div className="row clearfix">

<div className="form-group">
<form onSubmit={handleDutyRosterSubmit}>
<div class="row">
<div className="col-md-12 col-sm-12">


										{/* <div class="row" style={{ display: "flex" }}>
										<button style={{ marginLeft: "auto" }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											
										>
											Assign Shift
										</button>
									</div> */}
									
{/* <p ></p> */}
										<div className="form-group">
										
									
										<p style={{fontSize:'15px',fontFamily:'initial'}}>
The correct column order is (Employee ID, Attendance Date, Shift Code) and you must follow the csv file , otherwise you will get an error while importing the csv file. if you upload the employee who is not under your incharge it will be ignored
</p>

										<label className="form-label">Upload File <span className="form-required">*</span></label>
										<input type="file" onChange={handleDocumentChange} className="block w-full" /><br />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: xls, xlsx, csv (allowed file size 500 KB)</span><br />
										{/* <a href={filepath}><span style={{fontSize:'16px',fontWeight:'900',color:'red'}}>{document.document_file}</span></a> */}
										
										</div>
									</div>
									</div>


<button type="submit" className="btn btn-round btn-primary" disabled={isImporting || !docfile}>
{isImporting ? "Importing..." : "Import File"}
</button>
</form>

</div>


</div>

</div>


</div>
</div>

</form>




						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

												<div className="input-group">

													<select style={{
														height: '38px',
														minWidth: '70px',
														padding: '6px 10px',
														marginRight: '20px',
														fontSize: '14px',
														borderRadius: '4px',
														border: '1px solid #ced4da',
														outline: 'none',
														backgroundColor: '#fff',
														boxSizing: 'border-box'
													}}
														id="rowsPerPage"
														value={itemsPerPage}
														onChange={handleRowsPerPageChange}
													>
														<option value={10}>10</option>
														<option value={25}>25</option>
														<option value={50}>50</option>
														<option value={100}>100</option>
													</select>

													<div style={{ position: "relative", width: "300px" }}>

													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={handleSearch}
														style={{
															width: "100%",
															height: "38px",          // match the rows-per-page select
															padding: "6px 10px",
															paddingRight: "30px", // Extra space for the clear icon
															fontSize: "14px",
															boxSizing: "border-box",
														  }}
														// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
													/>

 {searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
	    </div>



												</div>

											</div>
										</div>












										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Department</th>
															<th>Employee</th>
															<th>Shift Code</th>
															<th>Shift Name</th>
															<th>Day</th>
															<th>Timing</th>
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((flrsft, index) => {

																return <tr key={index}>
																	<td className="d-flex">
																		
																	<span>{flrsft.department_name}</span>
																		
																	

																	</td>
																	<td>
																		<span>{flrsft.emp_info}</span>
																	</td>
																	<td>
																	<span>{flrsft.shift_code}</span>
																	</td>
																	<td>
																		<span>{flrsft.shift_name}</span>
																	</td>
																	<td>
																		<span>{flrsft.shift_date}</span>
																	</td>

																	<td>
																		<span>{flrsft.day}</span>
																	</td>

																	

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<Pagination
												currentPage={currentPage}
												totalPages={Math.ceil(filteredItems.length / itemsPerPage)}
												onPageChange={setCurrentPage}
											/>










										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>




			
			






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(DepartmentShift);